"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _framerMotion = require("framer-motion");

var _bodyScrollLock = require("body-scroll-lock");

var _ismobilejs = _interopRequireDefault(require("ismobilejs"));

var _Flex = _interopRequireDefault(require("../../Flex/Flex"));

var _MotionFlex = _interopRequireDefault(require("../../motionComponents/MotionFlex/MotionFlex"));

var _MotionBox = _interopRequireDefault(require("../../motionComponents/MotionBox/MotionBox"));

var _Text = _interopRequireDefault(require("../../Text/Text"));

var _Icon = _interopRequireDefault(require("../../Icon/Icon"));

var _utils = require("../../../utils");

// @ts-nocheck

/* eslint-disable no-nested-ternary */

/* eslint-disable react-hooks/exhaustive-deps */

/* eslint-disable react/jsx-props-no-spreading */
var KeyboardEventHandler = null;

if (typeof window !== "undefined") {
  KeyboardEventHandler = require("react-keyboard-event-handler");
}

var DropdownBody = (0, _styledComponents["default"])(_MotionFlex["default"]).withConfig({
  displayName: "MotionSelect__DropdownBody",
  componentId: "sc-191ccdc-0"
})(["border-radius:", "px;flex-direction:column;justify-content:flex-start;align-items:flex-start;align-content:flex-start;position:", ";cursor:", ";"], function (_ref) {
  var borderRadius = _ref.borderRadius;
  return borderRadius;
}, function (_ref2) {
  var dropdownRelative = _ref2.dropdownRelative;
  return dropdownRelative ? "static" : "absolute";
}, function (_ref3) {
  var disabled = _ref3.disabled;
  return disabled ? "not-allowed" : "auto";
});
var ScrollableFlex = (0, _styledComponents["default"])(_Flex["default"]).withConfig({
  displayName: "MotionSelect__ScrollableFlex",
  componentId: "sc-191ccdc-1"
})(["overflow-y:", ";overflow-x:hidden;scrollbar-color:auto transparent;flex-direction:column;&::-webkit-scrollbar{width:8px;margin-bottom:10px;}&::-webkit-scrollbar-track{color:transparent;}&::-webkit-scrollbar-thumb{background-color:", ";border-radius:5px;}"], function (_ref4) {
  var shouldScrollAppear = _ref4.shouldScrollAppear;
  return shouldScrollAppear ? "auto" : "hidden";
}, function (_ref5) {
  var theme = _ref5.theme,
      scrollBarThumbColor = _ref5.scrollBarThumbColor;
  return (0, _utils.colorStringToTheme)(theme, scrollBarThumbColor);
});
var BorderRadiusMotionFlex = (0, _styledComponents["default"])(_MotionFlex["default"]).withConfig({
  displayName: "MotionSelect__BorderRadiusMotionFlex",
  componentId: "sc-191ccdc-2"
})(["border-radius:", "px;cursor:", ";"], function (_ref6) {
  var borderRadius = _ref6.borderRadius;
  return borderRadius;
}, function (_ref7) {
  var disabled = _ref7.disabled;
  return disabled ? "not-allowed" : "auto";
});
var OverFlowText = (0, _styledComponents["default"])(_Text["default"]).withConfig({
  displayName: "MotionSelect__OverFlowText",
  componentId: "sc-191ccdc-3"
})(["white-space:nowrap;overflow:hidden;text-overflow:ellipsis;-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;"]);

var generateOptions = function generateOptions(_ref8) {
  var options = _ref8.options,
      onSelect = _ref8.onSelect,
      textStyling = _ref8.textStyling,
      selectedTextStyling = _ref8.selectedTextStyling,
      optionHeight = _ref8.optionHeight,
      selectedOption = _ref8.selectedOption;
  var optionVariants = {
    unActive: {
      opacity: 0,
      background: "rgba(0, 0, 0, 0.0)",
      transition: {
        ease: "easeInOut",
        duration: 0.12
      }
    },
    active: {
      opacity: 1,
      background: "rgba(0, 0, 0, 0.0)",
      transition: {
        ease: "easeInOut",
        duration: 0.12
      }
    },
    selected: {
      background: "rgba(0, 0, 0, 0.1)",
      opacity: 1,
      transition: {
        ease: "easeInOut",
        duration: 0.12,
        delay: 0
      }
    }
  };
  return options.map(function (option, index) {
    var thisOptionSelected = selectedOption.id === option.id;
    var currentStyle = thisOptionSelected ? selectedTextStyling : textStyling;
    return _react["default"].createElement(_framerMotion.AnimatePresence, {
      key: option.id
    }, _react["default"].createElement(_MotionFlex["default"], {
      onTap: function onTap() {
        onSelect(option.id);
      },
      style: {
        cursor: "pointer"
      },
      id: option.id,
      variants: optionVariants,
      animate: thisOptionSelected ? "selected" : "active",
      whileHover: "selected" // @ts-ignore
      ,
      minHeight: optionHeight,
      width: 1 / 1,
      alignItems: "center",
      alignContent: "center",
      mt: index === 0 ? 1 : 0,
      title: option.value
    }, _react["default"].createElement(OverFlowText, (0, _extends2["default"])({
      width: 1 / 1,
      id: option.id
    }, currentStyle), option.value)));
  });
};

var findOptionWithId = function findOptionWithId(options, id) {
  return options.find(function (option) {
    return option.id === id;
  }) || options[0];
};

var scrollControllerOptions = {
  reserveScrollBarGap: true
  /**
   * Dropdown input animated with Framer Motion.
   *
   * This component has the ability to automatically scale to the selected option text width.
   *
   * A option with a blank value, is used to define no option selected.
   *
   * To learn more about how to use this component, see examples within Storybook.
   *
   * @param {object} props React components passed in props
   * @param {string} [props.placeholder] Placeholder text
   * @param {string} [props.id] ID for input
   * @param {string} [props.helperText] Text that goes under input to provide help
   * @param {string} [props.label] Label for accessibility purposes (not visable)
   * @param {boolean} [props.disabled] Disables input
   * @param {boolean} [props.disabled] Disables input
   * @param {function} [props.onChange] Function that is called on option select
   * @param {function} [props.onBlur] Function that is called on input interaction
   * @param {number} [props.height] Height of input
   * @param {number} [props.minWidth] Minimum width of input
   * @param {number} [props.maxWidth] Maximum width of input
   * @param {number | string} [props.width] Sets width of input (Anything other than 'auto' stops automatic width adjustment)
   * @param {number} [props.maxExtendedHeight] Maximum height of extended option
   * @param {number} [props.optionHeight] Height of individual option
   * @param {number} [props.borderRadius] Border radius of input
   * @param {object} [props.textStyling] Styling for option text (unselected)
   * @param {object} [props.buttonTextStyling] Styling for button text
   * @param {object} [props.selectedTextStyling] Styling for option text (selected)
   * @param {object} [props.helperTextStyling] Styling for helper text
   * @param {object[]} [props.options] Options for dropdown
   * @param {string} [props.defaultOptionId] ID of default option
   * @param {string} [props.bg] Background color of input
   * @param {string} [props.dropdownBg] Background color of dropdown
   * @param {string} [props.scrollBarThumbColor] Color of scrollbar thumb
   * @param {string} [props.iconColor] Color of icon
   * @param {number} [props.extraWidth] Extra width applied after text
   * @param {boolean} [props.disableKeyboardInput] Disables keyboard control for input
   * @param {string} [props.valueId] Pass in value to externally change select
   * @param {boolean} [props.disableClearButton] Disables clear button functionality
   * @param {string} [props.iconName] Replaces default icon
   * @param {boolean} [props.noIconRotate] Stops icon from rotating on mouse hover
   * @param {string} [props.title] Force tooltip text on hover
   * @param {boolean} [props.dropdownRelative] Dropdown expand push lower components down
   * @param {number} [props.zIndex] Change z-index
   */

};

var MotionSelect = function MotionSelect(_ref9) {
  var _ref9$placeholder = _ref9.placeholder,
      placeholder = _ref9$placeholder === void 0 ? "" : _ref9$placeholder,
      _ref9$id = _ref9.id,
      id = _ref9$id === void 0 ? "" : _ref9$id,
      _ref9$label = _ref9.label,
      label = _ref9$label === void 0 ? "dropdown" : _ref9$label,
      _ref9$helperText = _ref9.helperText,
      helperText = _ref9$helperText === void 0 ? "" : _ref9$helperText,
      _ref9$disableKeyboard = _ref9.disableKeyboardInput,
      disableKeyboardInput = _ref9$disableKeyboard === void 0 ? false : _ref9$disableKeyboard,
      _ref9$disabled = _ref9.disabled,
      disabled = _ref9$disabled === void 0 ? false : _ref9$disabled,
      _ref9$onChange = _ref9.onChange,
      onChange = _ref9$onChange === void 0 ? function (selectedOption) {
    return selectedOption;
  } : _ref9$onChange,
      _ref9$onBlur = _ref9.onBlur,
      onBlur = _ref9$onBlur === void 0 ? function (event) {
    return event;
  } : _ref9$onBlur,
      _ref9$height = _ref9.height,
      height = _ref9$height === void 0 ? 40 : _ref9$height,
      _ref9$minWidth = _ref9.minWidth,
      minWidth = _ref9$minWidth === void 0 ? null : _ref9$minWidth,
      _ref9$maxWidth = _ref9.maxWidth,
      maxWidth = _ref9$maxWidth === void 0 ? null : _ref9$maxWidth,
      _ref9$maxExtendedHeig = _ref9.maxExtendedHeight,
      maxExtendedHeight = _ref9$maxExtendedHeig === void 0 ? null : _ref9$maxExtendedHeig,
      _ref9$optionHeight = _ref9.optionHeight,
      optionHeight = _ref9$optionHeight === void 0 ? 30 : _ref9$optionHeight,
      _ref9$width = _ref9.width,
      width = _ref9$width === void 0 ? "auto" : _ref9$width,
      _ref9$extraWidth = _ref9.extraWidth,
      extraWidth = _ref9$extraWidth === void 0 ? 78 : _ref9$extraWidth,
      _ref9$disableClearBut = _ref9.disableClearButton,
      disableClearButton = _ref9$disableClearBut === void 0 ? false : _ref9$disableClearBut,
      _ref9$borderRadius = _ref9.borderRadius,
      borderRadius = _ref9$borderRadius === void 0 ? 4 : _ref9$borderRadius,
      _ref9$textStyling = _ref9.textStyling,
      textStyling = _ref9$textStyling === void 0 ? {
    fontSize: 14,
    mx: 3,
    fontWeight: 400
  } : _ref9$textStyling,
      _ref9$buttonTextStyli = _ref9.buttonTextStyling,
      buttonTextStyling = _ref9$buttonTextStyli === void 0 ? {
    fontSize: 14,
    ml: 3,
    mr: 0,
    fontWeight: 400
  } : _ref9$buttonTextStyli,
      _ref9$selectedTextSty = _ref9.selectedTextStyling,
      selectedTextStyling = _ref9$selectedTextSty === void 0 ? {
    fontSize: 14,
    mx: 3,
    fontWeight: 500
  } : _ref9$selectedTextSty,
      _ref9$helperTextStyli = _ref9.helperTextStyling,
      helperTextStyling = _ref9$helperTextStyli === void 0 ? {
    color: "dark.2",
    fontSize: 2
  } : _ref9$helperTextStyli,
      _ref9$iconColor = _ref9.iconColor,
      iconColor = _ref9$iconColor === void 0 ? "dark.0" : _ref9$iconColor,
      _ref9$iconName = _ref9.iconName,
      iconName = _ref9$iconName === void 0 ? null : _ref9$iconName,
      _ref9$options = _ref9.options,
      options = _ref9$options === void 0 ? [{
    id: null,
    value: ""
  }] : _ref9$options,
      _ref9$defaultOptionId = _ref9.defaultOptionId,
      defaultOptionId = _ref9$defaultOptionId === void 0 ? null : _ref9$defaultOptionId,
      _ref9$bg = _ref9.bg,
      bg = _ref9$bg === void 0 ? "primary.0" : _ref9$bg,
      _ref9$dropdownBg = _ref9.dropdownBg,
      dropdownBg = _ref9$dropdownBg === void 0 ? "primary.2" : _ref9$dropdownBg,
      _ref9$scrollBarThumbC = _ref9.scrollBarThumbColor,
      scrollBarThumbColor = _ref9$scrollBarThumbC === void 0 ? "primary.0" : _ref9$scrollBarThumbC,
      _ref9$valueId = _ref9.valueId,
      valueId = _ref9$valueId === void 0 ? null : _ref9$valueId,
      _ref9$noIconRotate = _ref9.noIconRotate,
      noIconRotate = _ref9$noIconRotate === void 0 ? false : _ref9$noIconRotate,
      _ref9$title = _ref9.title,
      title = _ref9$title === void 0 ? "" : _ref9$title,
      _ref9$zIndex = _ref9.zIndex,
      zIndex = _ref9$zIndex === void 0 ? null : _ref9$zIndex,
      _ref9$dropdownRelativ = _ref9.dropdownRelative,
      dropdownRelative = _ref9$dropdownRelativ === void 0 ? false : _ref9$dropdownRelativ,
      props = (0, _objectWithoutPropertiesLoose2["default"])(_ref9, ["placeholder", "id", "label", "helperText", "disableKeyboardInput", "disabled", "onChange", "onBlur", "height", "minWidth", "maxWidth", "maxExtendedHeight", "optionHeight", "width", "extraWidth", "disableClearButton", "borderRadius", "textStyling", "buttonTextStyling", "selectedTextStyling", "helperTextStyling", "iconColor", "iconName", "options", "defaultOptionId", "bg", "dropdownBg", "scrollBarThumbColor", "valueId", "noIconRotate", "title", "zIndex", "dropdownRelative"]);
  var optionsWithRemovedBlank = options.filter(function (option) {
    return option.value;
  });

  var _useState = (0, _react.useState)(false),
      expanded = _useState[0],
      setExpanded = _useState[1];

  var getInitialSelectedOption = function getInitialSelectedOption() {
    if (valueId) {
      return findOptionWithId(options, valueId);
    }

    if (defaultOptionId) {
      return findOptionWithId(options, defaultOptionId);
    }

    return options[0];
  };

  var _useState2 = (0, _react.useState)(getInitialSelectedOption()),
      selectedOption = _useState2[0],
      setSelectedOption = _useState2[1];

  var scrollableFlexRef = (0, _react.useRef)();
  var calculatedWidth = (0, _utils.textWidthCalculator)({
    text: selectedOption.value || placeholder,
    // @ts-ignore
    fontFamily: textStyling.fontFamily || "Arial",
    fontSize: textStyling.fontSize || 12,
    minWidth: minWidth,
    maxWidth: maxWidth,
    extraWidth: extraWidth,
    desiredWidth: width
  });

  var _useState3 = (0, _react.useState)(calculatedWidth),
      previousWidth = _useState3[0],
      setPreviousWidth = _useState3[1];

  var widthControl = (0, _framerMotion.useAnimation)(); // Change width of input based on length of text

  (0, _react.useEffect)(function () {
    onChange(selectedOption);
    widthControl.start({
      width: [previousWidth, calculatedWidth],
      transition: {
        duration: 0.5
      }
    });
  }, [selectedOption]); // Change width of input based on length of text

  (0, _react.useEffect)(function () {
    onChange(selectedOption);
    widthControl.start({
      width: [previousWidth, calculatedWidth],
      transition: {
        duration: 0.5
      }
    });
  }, []); // Disable scroll if dropdown expanded (only on desktop)

  (0, _react.useEffect)(function () {
    if (typeof window !== "undefined") {
      if (expanded) {
        if (!(0, _ismobilejs["default"])(window.navigator).any) {
          (0, _bodyScrollLock.disableBodyScroll)(scrollableFlexRef, scrollControllerOptions);
        }
      } else {
        (0, _bodyScrollLock.enableBodyScroll)(scrollableFlexRef, scrollControllerOptions);
      }
    } // Conditional to handle Razzel bug

  }, [expanded]); // If new value is provided to component, automatically change selected input

  (0, _react.useEffect)(function () {
    if (valueId && selectedOption.id !== valueId) {
      setSelectedOption(findOptionWithId(options, valueId));
      setExpanded(false);
    } else {
      setSelectedOption(getInitialSelectedOption());
      setExpanded(false);
    }
  }, [valueId]);

  var handleKeyPress = function handleKeyPress(key) {
    var currentOptionIndex = options.findIndex(function (option) {
      return option.id === selectedOption.id;
    });
    var resultRes = null;

    if (expanded) {
      switch (key) {
        case "down":
          resultRes = options[currentOptionIndex + 1];

          if (resultRes) {
            setSelectedOption(resultRes);
          }

          break;

        case "up":
          resultRes = options[currentOptionIndex - 1];

          if (resultRes) {
            setSelectedOption(resultRes);
          }

          break;

        case "enter":
          setExpanded(false);
          break;

        default:
          break;
      }
    }
  };

  var animationDuration = 0.04;
  var dropdownBodyVariants = {
    unActive: function unActive(childrenAmount) {
      return {
        height: height + "px",
        paddingBottom: "0px",
        transition: {
          ease: "easeInOut",
          duration: childrenAmount * animationDuration > 0.2 ? 0.2 : childrenAmount * animationDuration,
          delay: animationDuration,
          staggerChildren: animationDuration,
          staggerDirection: -1
        }
      };
    },
    active: function active(childrenAmount) {
      return {
        height: "auto",
        paddingBottom: (childrenAmount > 0 ? borderRadius : 0) + "px",
        transition: {
          ease: "easeInOut",
          duration: childrenAmount * animationDuration > 0.2 ? 0.2 : childrenAmount * animationDuration,
          staggerChildren: animationDuration,
          delayChildren: animationDuration,
          staggerDirection: 1
        }
      };
    }
  };
  var iconVariants = {
    unActive: {
      transform: "rotate(0deg)",
      transition: {
        duration: 0.3,
        ease: "easeInOut"
      }
    },
    active: {
      transform: "rotate(180deg)",
      transition: {
        duration: 0.3,
        ease: "easeInOut"
      }
    }
  };

  var handleSelect = function handleSelect(selectedId) {
    setSelectedOption(findOptionWithId(options, selectedId));
  }; // Internal dropdown scroll


  var shouldScrollAppear = function shouldScrollAppear() {
    if (!maxExtendedHeight) {
      return false;
    }

    if (optionsWithRemovedBlank.length * optionHeight + height > maxExtendedHeight) {
      return true;
    }

    return false;
  };

  var getIconCursor = function getIconCursor() {
    if (disabled) {
      return "not_allowed";
    }

    if (disableClearButton) {
      return "auto";
    }

    return selectedOption.value ? "pointer" : "auto";
  };

  return _react["default"].createElement(_react["default"].Fragment, null, KeyboardEventHandler && _react["default"].createElement(KeyboardEventHandler, {
    handleKeys: ["up", "down", "enter"],
    onKeyEvent: function onKeyEvent(key) {
      return handleKeyPress(key);
    },
    isDisabled: !disableKeyboardInput && !expanded,
    isExclusive: true
  }), _react["default"].createElement(_MotionBox["default"], (0, _extends2["default"])({
    className: "dropdown_wrapper",
    onAnimationComplete: function onAnimationComplete() {
      setPreviousWidth(calculatedWidth);
    },
    style: {
      display: dropdownRelative ? "block" : "flex",
      position: dropdownRelative ? "static" : "relative",
      zIndex: zIndex
    },
    height: dropdownRelative ? "auto" : height // @ts-ignore

  }, props, {
    animate: widthControl
  }), _react["default"].createElement(DropdownBody // @ts-ignore
  , {
    borderRadius: borderRadius,
    id: id,
    bg: dropdownBg,
    maxHeight: maxExtendedHeight,
    className: "dropdown_body_wrapper",
    onHoverStart: function onHoverStart() {
      if (!disabled) {
        setExpanded(true);

        if (scrollableFlexRef && scrollableFlexRef.current) {
          // @ts-ignore
          scrollableFlexRef.current.scrollTop = 0;
        }
      }
    },
    onTap: function onTap(e) {
      if (!disabled) {
        setExpanded(!expanded);
        onBlur(e);

        if (scrollableFlexRef && scrollableFlexRef.current) {
          // @ts-ignore
          scrollableFlexRef.current.scrollTop = 0;
        }
      }
    },
    width: 1 / 1,
    disabled: disabled,
    onHoverEnd: function onHoverEnd() {
      return setExpanded(false);
    },
    variants: dropdownBodyVariants,
    initial: "unActive",
    dropdownRelative: dropdownRelative,
    custom: optionsWithRemovedBlank.length,
    animate: expanded ? "active" : "unActive"
  }, _react["default"].createElement(BorderRadiusMotionFlex // @ts-ignore
  , {
    bg: bg,
    width: 1 / 1,
    className: "dropdown_button",
    borderRadius: borderRadius,
    justifyContent: "space-between",
    alignItems: "center",
    alignContent: "center",
    height: height,
    minHeight: height,
    disabled: disabled
  }, label && _react["default"].createElement("label", {
    htmlFor: id,
    className: "dropdown_label",
    style: {
      visibility: "hidden",
      height: 0,
      width: 0,
      position: "absolute"
    },
    id: id
  }, label), _react["default"].createElement(OverFlowText, (0, _extends2["default"])({}, buttonTextStyling, {
    title: title || selectedOption.value || placeholder
  }), selectedOption.value || placeholder), _react["default"].createElement(_MotionFlex["default"], {
    variants: iconVariants,
    initial: "unActive",
    className: "dropdown_button_icon_wrapper",
    justifyContent: "center",
    alignItems: "center",
    alignContent: "center",
    animate: function () {
      if (noIconRotate) {
        return "unActive";
      }

      if (disableClearButton) {
        return optionsWithRemovedBlank.length === 0 ? "unActive" : expanded ? "active" : "unActive";
      }

      return optionsWithRemovedBlank.length === 0 ? "unActive" : expanded && !selectedOption.value ? "active" : "unActive";
    }(),
    width: 20,
    height: 20,
    ml: 2,
    mr: 3
  }, _react["default"].createElement(_MotionFlex["default"], {
    className: "dropdown_button_icon_wrapper_inner",
    whileHover: {
      scale: selectedOption.value && !disabled && !disableClearButton ? 1.05 : 1
    },
    justifyContent: "center",
    alignItems: "center",
    alignContent: "center"
  }, _react["default"].createElement(_Icon["default"], {
    className: "dropdown_button_icon",
    style: {
      cursor: getIconCursor()
    },
    color: iconColor,
    name: function () {
      if (iconName) {
        return iconName;
      }

      return disabled || disableClearButton ? "arrow_drop_down" : selectedOption.value ? "close" : "arrow_drop_down";
    }(),
    onClick: function onClick() {
      if (selectedOption.value && !disableClearButton) {
        setSelectedOption(findOptionWithId(options, defaultOptionId));
        setExpanded(false);
      }
    }
  })))), _react["default"].createElement(ScrollableFlex // @ts-ignore
  , {
    scrollBarThumbColor: scrollBarThumbColor,
    className: "dropdown_body",
    width: 1 / 1,
    height: "auto",
    shouldScrollAppear: shouldScrollAppear(),
    maxHeight: maxExtendedHeight - height,
    ref: scrollableFlexRef
  }, generateOptions({
    options: optionsWithRemovedBlank,
    onSelect: handleSelect,
    optionHeight: optionHeight,
    textStyling: textStyling,
    selectedTextStyling: selectedTextStyling,
    selectedOption: selectedOption
  }))), _react["default"].createElement(OverFlowText, (0, _extends2["default"])({
    mt: height + 4
  }, helperTextStyling), helperText)));
};

var _default = MotionSelect;
exports["default"] = _default;